declare global {
  interface Window {
    PaystackPop: {
      setup(opts: {
        key: string
        email: string
        amount: number
        currency: string
        ref: string
        access_code?: string
        callback: (response: { reference: string }) => void
        onClose: () => void
      }): { openIframe(): void }
    }
  }
}

let scriptPromise: Promise<void> | null = null

function loadPaystackScript(): Promise<void> {
  if (window.PaystackPop) return Promise.resolve()
  if (scriptPromise) return scriptPromise

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.id = "paystack-inline-js"
    script.src = "https://js.paystack.co/v1/inline.js"
    script.onload = () => resolve()
    script.onerror = () => {
      scriptPromise = null
      reject(new Error("Failed to load Paystack script"))
    }
    document.head.appendChild(script)
  })

  return scriptPromise
}

export const PaystackPopup = {
  mounted(this: {
    el: HTMLElement
    pushEvent: (event: string, payload: object) => void
    handleEvent: (event: string, cb: (payload: object) => void) => void
  }) {
    // Pre-load the Paystack script immediately so it's ready when the user clicks Pay
    loadPaystackScript().catch(() => {})

    this.handleEvent(
      "open_paystack_popup",
      async ({ access_code, reference, amount_kes, public_key, email }: any) => {
        try {
          await loadPaystackScript()

          const handler = window.PaystackPop.setup({
            key: public_key,
            email: email || "student@lms.co.ke",
            amount: amount_kes * 100,
            currency: "KES",
            ref: reference,
            access_code,
            callback: (response: { reference: string }) => {
              this.pushEvent("paystack_success", { reference: response.reference })
            },
            onClose: () => {
              this.pushEvent("paystack_cancelled", {})
            },
          })

          handler.openIframe()
        } catch (err) {
          console.error("Paystack load error:", err)
          this.pushEvent("paystack_load_error", {})
        }
      },
    )
  },
}
